import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

export const Home = () => {
  const [cookies] = useCookies(["access_token"]);
  const Notifications = (msg) => toast(msg);
  const UserID = window.localStorage.getItem("UserID");
  const [post, setPost] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const post = await axios.get("https://blogapi21.onrender.com/posts");
        setPost(post.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchPosts();
    const fetchSavedPosts = async () => {
      try {
        await axios.get(
          `https://blogapi21.onrender.com/posts/saves/ID/${UserID}`
        );
      } catch (error) {
        console.log(error);
      }
    };
    if (cookies.access_token) {
      fetchSavedPosts();
    }
  }, [UserID, cookies.access_token]);

  const SavePost = async (id) => {
    try {
      await axios.put("https://blogapi21.onrender.com/posts/", {
        id,
        UserID,
      });
      Notifications("Post Saved");
    } catch (error) {
      console.log(error);
      Notifications(error.response.data.message);
    }
  };

  return (
    <>
      <div className="flex flex-col justify-center align-middle items-center">
        <h1 className="mb-10 text-5xl">Posts</h1>
        <ul className="flex justify-center flex-col-reverse items-center">
          {post.map((post) => (
            <li
              key={post._id}
              className="border w-[70%] border-primary rounded-2xl overflow-hidden p-9 flex flex-col justify-center text-center my-7"
            >
              {cookies.access_token ? (
                <div className="flex justify-between pb-4">
                  <h2 className="text-2xl">{post.title}</h2>
                  <button
                    className="btn btn-primary text-primary-content btn-outline"
                    onClick={() => SavePost(post._id)}
                  >
                    Save Post
                  </button>
                </div>
              ) : (
                <div className="flex justify-center pb-4">
                  <h2 className="text-2xl">{post.title}</h2>
                </div>
              )}
              <div className="border w-[85%] border-secondary rounded-2xl overflow-hidden p-3 mx-auto text-left">
                <p>{post.content}</p>
              </div>
              <div className="mt-9 mb-3">
                <p className="text-xs">Posted by: {post.username}</p>
                <p className="text-xs">Posted on: {post.datetime}</p>
              </div>
              {post.image ? (
                <div className="m-auto">
                  <img src={post.image} alt="post" />
                </div>
              ) : null}
              {post.tag.length > 0 ? (
                <div className="m-auto mt-4">
                  <p>Tags:</p>
                  {post.tag.map((tag) => (
                    <div
                      key={tag}
                      className="badge badge-accent badge-outline border-2 rounded-lg p-3 mt-2 mx-1"
                    >
                      {tag}
                    </div>
                  ))}
                </div>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
